var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6884 21.4192C41.8915 20.6301 23.9898 21.4543 23.4791 21.4195C21.9426 21.3311 20.0456 21.7036 19.0459 22.1788C14.9927 24.1055 15.4994 29.8799 15.091 34.553C14.2924 43.6916 14.9435 53.2818 14.9435 62.2474C14.9435 66.1352 13.8526 72.0308 17.7521 75.0715C21.0712 77.6479 26.9204 77.6247 30.4949 77.6015C39.466 77.5666 44.2823 77.3577 46.8006 74.0154C48.7039 71.497 48.762 67.2842 49.0289 64.3596C49.7252 56.7348 49.8065 36.4832 49.0057 29.7172C48.4486 25.133 47.6594 22.2548 44.6884 21.4192Z",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41406 27.4564C2.55079 26.5659 3.71295 28.2634 4.39659 28.6252C5.94616 29.4322 7.49574 30.1557 9.11367 30.768",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3379 10.1325C12.3829 10.0778 12.9683 11.3913 13.0246 11.5373C13.869 13.3251 14.7246 15.0765 15.5464 16.8826",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4034 1.96405C34.2252 1.37195 34.1134 3.15033 34.0564 3.71625C33.9429 4.95584 34.0012 4.79401 33.8288 6.00686C33.485 8.75581 33.1411 11.4778 32.9148 14.2264",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2266 16.883C50.257 16.883 51.9314 15.0494 52.0836 14.9039C54.3364 12.6628 56.5588 10.4217 58.6594 8.03516",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0098 28.5637C58.6026 27.7878 60.1291 26.8303 61.5892 25.8398",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1532 21.9725C27.0371 22.1349 27.4085 22.8661 27.4665 23.0286C27.8379 24.1891 27.9308 25.2684 29.1493 25.7675C30.8785 26.4754 33.1532 26.2317 34.9521 25.9648C35.4395 25.8951 36.2055 25.9764 36.6001 25.6746C37.3428 25.0943 37.6794 24.0498 38.0508 23.2026C38.2248 22.7964 38.6194 22.2046 38.6194 21.752L27.1532 21.9725Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9961 72.1973H37.388",
    stroke: "black",
    strokeWidth: 3.14275,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "phone.ab1b7289fd6cdb44a49cea4a4d1baca4.svg";